import type { FaireProductEntity } from "../../entity_types/product";

export const p_xm7cax6edw: FaireProductEntity = {
  token: "p_xm7cax6edw",
  type: "product",
  name: "Newborn Knotted Gown - Boone",
  brandToken: "b_qba2f8n5gh",
  brandName: "Copper Pearl",
  imageUrl: "https://cdn.faire.com/fastly/ae2fdb487747c1b64a993c208bfcae59305e293bc5dad39956714d7bdf7bc984.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6fec95c667d2aca80af5d7762c8fa9a75ebb8b119a682c242bbc83f191e9e07f.jpeg",
    "https://cdn.faire.com/fastly/bb430fc335aec5deb1fd293c4b5833760d3dc03cece881427e26e613c36b0a67.jpeg",
    "https://cdn.faire.com/fastly/62f41d27a3f6e60434dd5204e95292b2bfad33ac87d33f33a3add83cc00dffea.jpeg",
    "https://cdn.faire.com/fastly/487d195dd03f6dd30355d5dc4a4d87fe3775fcb5582a578aff54c9f348af4635.jpeg",
    "https://cdn.faire.com/fastly/ad003ed984f027f7e3f022470f9d48d414741953dab02fe5583161820ca745db.jpeg"
  ],
  priceDollars: 14,
  description: "* \nPREMIUM POLYESTER/RAYON BLEND – Made with the same premium knit fabric as our beloved swaddles, this soft and stretchy gown ties at the bottom for easy diaper changes—and has room to grow.\n\n * GENEROUS SIZE – A length of 25 inches and width of 8 inches. \n * \nBONUS FEATURES – Our knotted gowns feature unique snaps to make dressing a breeze, along with fold-over hand mitts to prevent scratching.\n\n * \nTRENDY, HIGH QUALITY DESIGNS – At Copper Pearl we pride ourselves on making high quality products that always look great on babies, moms, or in your nursery. Our knotted gowns are simple, modern, and sure to elevate any baby’s style.\n\n * \nPAIR PERFECTLY WITH COPPER PEARL PRODUCTS – Our trendy, newborn knotted gowns flaunt your favorite Copper Pearl prints and patterns. They are made to coordinate perfectly with products you already own and love!",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:15.801Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
